// src/utils/refreshBus.ts
import mitt from 'mitt'
export const refreshBus = mitt()
